import Swiper, {Navigation, Pagination, Thumbs, Zoom, Lazy} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

(function ($) {
  'use strict';
  Drupal.behaviors.swiper = {
    attach: function (context, settings) {
      initSwiper();
    }
  };
}(jQuery));

function initSwiper() {

  var productSlider = new Swiper("#productSlider", {
    modules: [Navigation, Pagination],
    observer: true,
    spaceBetween: 15,
    navigation: {
      nextEl: ".products__slider-next",
      prevEl: ".products__slider-prev",
    },
    pagination: {
      el: ".products__slider-pagination",
      type: "fraction",
    },
    centerInsufficientSlides: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      414: {
        slidesPerView: "auto",
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1400: {
        slidesPerView: 3,
        spaceBetween: 50,
      }
    },
  });

  var popularArticlesSlider = new Swiper("#popularArticles", {
    modules: [Navigation],
    observer: true,
    spaceBetween: 15,
    navigation: {
      nextEl: ".popular-articles__slider-next",
      prevEl: ".popular-articles__slider-prev",
    },
    centerInsufficientSlides: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      414: {
        slidesPerView: "auto",
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1400: {
        slidesPerView: 3,
        spaceBetween: 50,
      }
    },
  });

  var benefitsSlider = new Swiper("#benefitsSlider", {
    modules: [Navigation, Pagination],
    slidesPerView: 1.075,
    spaceBetween: 15,
    centeredSlides: true,
    observer: true,
    navigation: {
      nextEl: ".benefits__slider-next",
      prevEl: ".benefits__slider-prev",
    },
    pagination: {
      el: ".benefits__slider-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        centeredSlides: false,
        slidesPerView: 1,
        spaceBetween: 0,
      }
    }
  });

  var articlesSlider = new Swiper("#articlesSlider", {
    modules: [Navigation, Pagination],
    spaceBetween: 15,
    observer: true,
    autoHeight: true,
    navigation: {
      nextEl: ".articles__slider-next",
      prevEl: ".articles__slider-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      414: {
        slidesPerView: "auto",
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1400: {
        slidesPerView: 3,
        spaceBetween: 50,
      }
    },
    pagination: {
      el: ".articles_slider-pagination",
      type: "fraction",
    },
  });

  var articlesVideoSlider = new Swiper("#articlesVideoSlider", {
    modules: [Navigation, Pagination],
    slidesPerView: 1.075,
    spaceBetween: 15,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 50,
      }
    },
    pagination: {
      el: ".articles_slider-pagination",
      type: "fraction",
    },
  });

  var swiperAdvantage = new Swiper("#advantageSlider", {
    modules: [Navigation, Pagination],
    slidesPerView: 1.075,
    spaceBetween: 15,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 50,
      }
    },
    pagination: {
      el: ".advantage__slider-pagination",
      type: "fraction",
    },
  });

  var swiperDogAdvantage = new Swiper("#advantageDogSlider", {
    modules: [Navigation, Pagination],
    slidesPerView: 1.075,
    spaceBetween: 15,
    breakpoints: {
      768: {
        slidesPerView: 5,
        spaceBetween: 50,
      }
    },
    pagination: {
      el: ".advantage__slider-pagination",
      type: "fraction",
    },
  });

  var assortmentSlider = new Swiper("#assortmentSlider", {
    modules: [Navigation],
    // slidesPerView: 1.075,
    slidesPerView: 1,
    spaceBetween: 15,
    navigation: {
      nextEl: ".assortment__slider-next",
      prevEl: ".assortment__slider-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
      }
    }
  });

  var articleRecommendSlider = new Swiper("#articleRecommendSlider", {
    modules: [Navigation, Pagination],
    slidesPerView: 1.075,
    spaceBetween: 15,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 40,
      }
    },
    navigation: {
      nextEl: ".article__slider-next",
      prevEl: ".article__slider-prev",
    },
    pagination: {
      el: ".articles_slider-pagination",
      type: "fraction",
    },
  });

  var articleGallerySlider = new Swiper("#articleGallerySlider", {
    modules: [Navigation],
    slidesPerView: 1.075,
    spaceBetween: 15,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 50,
      }
    },
    navigation: {
      nextEl: ".article__slider-next",
      prevEl: ".article__slider-prev",
    },
  });

  var articleCareSlider = new Swiper("#articleCareSlider", {
    modules: [Navigation],
    slidesPerView: 1.075,
    spaceBetween: 15,
    breakpoints: {
      768: {
        slidesPerView: 5,
        spaceBetween: 30,
      }
    },
    navigation: {
      nextEl: ".article__slider-next",
      prevEl: ".article__slider-prev",
    },
  });

  //initProductDetailSwiper();
}

export function initProductDetailSwiper() {
  // var swiperDetailProductThumbs = new Swiper("#swiperDetailProductThumbs", {
  //   spaceBetween: 20,
  //   slidesPerView: 3,
  //   watchSlidesProgress: true,
  //   grabCursor: true,
  //   threshold: 10,
  //   observer: true,
  //   breakpoints: {
  //     1024: {
  //       spaceBetween: 40,
  //     }
  //   }
  // });

  // var swiperDetailProductMain = new Swiper("#swiperDetailProductMain", {
  //   modules: [Navigation, Thumbs],
  //   spaceBetween: 0,
  //   grabCursor: true,
  //   observer: true,
  //   navigation: {
  //     nextEl: ".detail-product__slider-next",
  //     prevEl: ".detail-product__slider-prev",
  //   },
  //   thumbs: {
  //     swiper: swiperDetailProductThumbs,
  //   }
  // });

  // var swiperModalDetailProductThumbs = new Swiper("#swiperModalDetailProductThumbs", {
  //   spaceBetween: 20,
  //   slidesPerView: "auto",
  //   freeMode: true,
  //   watchSlidesProgress: true,
  //   grabCursor: true,
  //   threshold: 10,
  //   observer: true,
  //   breakpoints: {
  //     1024: {
  //       spaceBetween: 40,
  //     }
  //   },
  //   on: {
  //     slideChange: () => {
  //       productSlideTo();
  //       swiperModalDetailProductMain.zoom.out();
  //     }
  //   },
  // });

  // var swiperModalDetailProductMain = new Swiper("#swiperModalDetailProductMain", {
  //   modules: [Navigation, Thumbs, Zoom, Lazy],
  //   zoom: {
  //     maxRatio: 3,
  //     minRatio: 1
  //   },
  //   passiveListeners: false,
  //   grabCursor: true,
  //   spaceBetween: 0,
  //   observer: true,
  //   navigation: {
  //     nextEl: ".detail-product__slider-next",
  //     prevEl: ".detail-product__slider-prev",
  //   },
  //   thumbs: {
  //     swiper: swiperModalDetailProductThumbs,
  //   },
  //   preloadImages: false,
  //   lazy: true,
  //   on: {
  //     slideChange: () => {
  //       productSlideTo();
  //       swiperModalDetailProductMain.zoom.out();
  //     }
  //   },
  // });

  // function productSlideTo () {
  //   swiperDetailProductMain.slideTo(swiperModalDetailProductMain.activeIndex);
  //   swiperDetailProductThumbs.slideTo(swiperModalDetailProductMain.activeIndex);
  // }

  // var productModal = document.querySelector('.detail-product__modal');
  // var productSlides = document.querySelectorAll('.detail-product__slider--main .swiper-slide');
  // if (productSlides) {
  //   productSlides.forEach((slide) => {
  //     slide.addEventListener('click', () => {
  //       var idx = Number(slide.getAttribute('data-slide-index'));
  //       swiperModalDetailProductMain.slideTo(idx);
  //       swiperModalDetailProductThumbs.slideTo(idx);
  //       productModal.classList.add('detail-product__modal_open');
  //       document.body.classList.add('overflow');
  //     });
  //   });
  // }
  // var closeBtnProductModal = document.querySelector('.detail-product__modal-close');
  // if (closeBtnProductModal) {
  //   closeBtnProductModal.addEventListener('click', function () {
  //     productModal.classList.remove('detail-product__modal_open');
  //     document.body.classList.remove('overflow');
  //     swiperModalDetailProductMain.zoom.out();
  //   });
  // }

  // var productZoomPlus = document.querySelector('[data-product-zoom-plus]');
  // var productZoomMinus = document.querySelector('[data-product-zoom-minus]');
  // if (productZoomPlus && productZoomMinus ) {
  //   productZoomPlus.addEventListener('click', () => {
  //     swiperModalDetailProductMain.zoom.in();
  //   });
  //   productZoomMinus.addEventListener('click', () => {
  //     swiperModalDetailProductMain.zoom.out();
  //   });
  // }
}
